import { render, staticRenderFns } from "./PostFooter.vue?vue&type=template&id=5c0a2f96&"
import script from "./PostFooter.vue?vue&type=script&lang=ts&"
export * from "./PostFooter.vue?vue&type=script&lang=ts&"
import style0 from "./PostFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports